export default class LocalToGlobal {
  constructor() {
    this.switchWorker = null
    this.onCloseSaveFilePanel = null
    this.doSaveFile = null
    this.onCloseIManageDlgForConvertMultiFiles = null
  }
  setSwitchWorker(method) {
    this.switchWorker = method
  }
  setOnCloseSaveFilePanel(method) {
    this.onCloseSaveFilePanel = method
  }
  setDoSaveFile(method) {
    this.doSaveFile = method
  }
  setOnCloseIManageDlgForConvertMultiFiles(method) {
    this.onCloseIManageDlgForConvertMultiFiles = method
  }
}